module.exports = __webpack_public_path__ + "img/senalandotxt.cbe22e1b.png";